module.exports = "<main>\n  Contents...\n</main>\n"